import { Component, input, output } from '@angular/core'
import { BaseAction } from '../../models/base-action.model'

@Component({
	selector: 'lowgile-results-list',
	templateUrl: './results-list.component.html',
	styleUrls: ['./results-list.component.scss'],
	standalone: false,
})
export class ResultsListComponent {
	actions = input<BaseAction[]>([])
	activeIndex = input<number>(0)
	query = input<string>('')
	actionSelect = output<BaseAction>()

	onActionSelect(action: BaseAction): void {
		this.actionSelect.emit(action)
	}
}
